{
  "actions": {
    "add-filters": "Add filters",
    "clear-search": "Clear search",
    "clear-filters": "Clear filters",
    "select-fields": "Select fields"
  },
  "text": {
    "field-type": "Field type",
    "condition": "Condition",
    "operator": "Operator",
    "value": "Value"
  },
  "field-types": {
    "keyword": "String",
    "text": "Text",
    "date": "Date and time",
    "long": "Number (integer)",
    "integer": "Number (integer)",
    "short": "Number (integer)",
    "byte": "Number (integer)",
    "float": "Number (float)",
    "double": "Number (float)",
    "half_float": "Number (float)"
  },
  "dsl-blocks": {
    "must": {
      "label": "Must",
      "description": "Must match all filters"
    },
    "should": {
      "label": "Should",
      "description": "Must match at least one filter"
    },
    "must_not": {
      "label": "Must Not",
      "description": "Must not match any filter"
    },
    "filter": {
      "label": "Filter",
      "description": "Fast exact matching (cached)"
    }
  },
  "filter-types": {
    "term": {
      "label": "Exact Value",
      "description": "Matches one exact value",
      "placeholder": "Enter exact value"
    },
    "terms": {
      "label": "Multiple Values",
      "description": "Matches any of listed values",
      "placeholder": "Enter multiple values"
    },
    "prefix": {
      "label": "Prefix",
      "description": "Starts with given text",
      "placeholder": "Enter prefix"
    },
    "range": {
      "label": "Range",
      "description": "Within given range",
      "placeholderStart": "Enter start",
      "placeholderEnd": "Enter end"
    },
    "exists": {
      "label": "Exists",
      "description": "Field has any value"
    },
    "match": {
      "label": "Contains Text",
      "description": "Contains analyzed text",
      "placeholder": "Enter text"
    },
    "match_phrase": {
      "label": "Exact Phrase",
      "description": "Contains exact phrase",
      "placeholder": "Enter text"
    },
    "match_phrase_prefix": {
      "label": "Phrase Prefix",
      "description": "Starts with exact phrase",
      "placeholder": "Enter text"
    },
    "multi_match": {
      "label": "Multiple Fields",
      "description": "Searches across fields",
      "placeholder": "Enter text"
    }
  }
}